import { FC, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useAppDispatch } from "store";
import { getProfile } from "store/actions/profile";

const InsuranceLayout: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  return <Outlet />;
};

export default InsuranceLayout;
